import { useAxiosClient } from '..';

export const useLanguageApi = () => {
    const { axiosClient } = useAxiosClient();

    return {
        getLanguages: async () => (await axiosClient.get(`/v1/language`)).data,
    }
}